import React, { useState } from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { V2Button } from '@abyss/web/ui/Button';

import classNames from 'classnames';

import styles from './riders.module.css';

export const Riders = () => {
  const [ridersSelected, setRidersSelected] = useState(false);

  return (
    <div>
      {ridersSelected && (
        <div className={styles.riderSections}>
          <div className={styles.riderBox}>
            <div className={styles.riderMeta}>
              <div className={styles.riderTitle}>Rider 1</div>
              <div className={styles.riderPrice}>$38.95 additional rate</div>
            </div>
            <ul className={styles.riderList}>
              <li>100% Part A deductible</li>
              <li>100% Part B excess coverage</li>
              <li>
                Preventive care (not covered by Medicare) - Plan pays first $120
                each calendar year
              </li>
            </ul>
            <div className={styles.riderRemove}>
              <V2Button variant="text" css={{ minHeight: '0', padding: '0' }}>
                Remove
              </V2Button>
            </div>
          </div>

          <div className={styles.riderBox}>
            <div className={styles.riderMeta}>
              <div className={styles.riderTitle}>Rider 2</div>
              <div className={styles.riderPrice}>$20.42 additional rate</div>
            </div>
            <ul className={styles.riderList}>
              <li>100% Part B deductible</li>
            </ul>
            <div className={styles.riderBanner}>
              <div className={styles.riderBannerMedia}>
                <IconSymbol icon="warning" variant="outlined" />
              </div>
              <div className={styles.riderBannerContent}>
                This rider is only available to those first eligible for
                Medicare before 2025.
              </div>
            </div>
            <div className={styles.riderRemove}>
              <V2Button variant="text" css={{ minHeight: '0', padding: '0' }}>
                Remove
              </V2Button>
            </div>
          </div>
        </div>
      )}

      <V2Button
        variant="text"
        className={styles.thebutton}
        onClick={() => {
          setRidersSelected(true);
        }}
      >
        <span className={styles.wrap}>
          <span className={styles.icon}>
            <IconSymbol
              className={styles.thebutton}
              icon="add_box"
              color="#002677"
              variant="outlined"
              size="22px"
            />
          </span>
          {ridersSelected === false && <span>View and add riders</span>}

          {ridersSelected && <span>Add/Edit riders</span>}
        </span>
      </V2Button>
    </div>
  );
};
